import * as XLSX from "xlsx";

/**
 * Converte un anno/mese/giorno in serial number Excel.
 * Tiene conto del bug Lotus 1-2-3 (Excel considera il 1900 bisestile).
 */
function dateToExcelSerial(y, m, d) {
  const jsDate = Date.UTC(y, m - 1, d);
  const excelEpoch = Date.UTC(1899, 11, 31);
  const msPerDay = 86400000;
  let serial = (jsDate - excelEpoch) / msPerDay;
  if (serial >= 60) serial += 1;
  return serial;
}

/**
 * Post-processa un worksheet XLSX: converte celle con date stringa (YYYY/MM/DD o YYYY-MM-DD)
 * o Date objects in celle Excel di tipo data con formato dd/mm/yyyy.
 * Questo rende le date ordinabili in Excel e visualizzate in formato italiano.
 */
export function formatDateCells(ws) {
  if (!ws["!ref"]) return ws;
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const dateRegex = /^\d{4}[\/\-]\d{2}[\/\-]\d{2}$/;

  for (let R = range.s.r + 1; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const addr = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[addr];
      if (!cell || cell.v == null) continue;

      let y, m, d;

      if (cell.v instanceof Date) {
        y = cell.v.getFullYear();
        m = cell.v.getMonth() + 1;
        d = cell.v.getDate();
      } else if (typeof cell.v === "string" && dateRegex.test(cell.v)) {
        const parts = cell.v.split(/[\/\-]/);
        y = parseInt(parts[0]);
        m = parseInt(parts[1]);
        d = parseInt(parts[2]);
      } else {
        continue;
      }

      cell.t = "n";
      cell.v = dateToExcelSerial(y, m, d);
      cell.z = "dd/mm/yyyy";
      delete cell.w;
    }
  }

  return ws;
}

/**
 * Post-processa un worksheet ExcelJS: converte celle con date stringa (YYYY/MM/DD o YYYY-MM-DD)
 * in celle Excel di tipo data con formato dd/mm/yyyy.
 */
export function formatDateCellsExcelJS(worksheet) {
  const dateRegex = /^\d{4}[\/\-]\d{2}[\/\-]\d{2}$/;

  worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    if (rowNumber === 1) return; // skip header
    row.eachCell({ includeEmpty: false }, (cell) => {
      if (typeof cell.value === "string" && dateRegex.test(cell.value)) {
        const parts = cell.value.split(/[\/\-]/);
        cell.value = new Date(Date.UTC(
          parseInt(parts[0]),
          parseInt(parts[1]) - 1,
          parseInt(parts[2])
        ));
        cell.numFmt = "dd/mm/yyyy";
      }
    });
  });

  return worksheet;
}
